import { get } from './ajax'

/**
 *
 * @param {integer} cents
 * @param {boolean} [dropZeros=true] if true (default) drops .00 for example: 5.00 -> 5 but 5.05 -> 5.05
 * @returns {number} cents converted into dollars
 */
function centsToDollars(cents, dropZeros = true) {
  let dollars = (cents / 100).toFixed(2)
  if (dropZeros && dollars % 1 === 0) {
    dollars = parseFloat(dollars)
  }
  return dollars
}
/**
 *
 * @param {float} dollars - the dollar amount to drop zeros, only drops if 2.00 not 2.10
 * @returns {integer}
 */
function dropZeros(dollars) {
  if (dollars % 1 === 0) {
    dollars = parseFloat(dollars)
  }
  return dollars
}

/**
 *
 * @param {float} dollars
 * @returns {string}
 */
function changeDecimalSeparator(dollars) {
  const iso_code = window.Solawave_Store.cart.currency.iso_code;
  if (iso_code == "EUR" || iso_code == "MXN") {
    dollars = dollars.toString().replace('.', ',')
  }
  return dollars
}

/**
 *
 * @param {String} src - Shopify image src in order to edit size
 * @param {Integer} size - Size to edit image too
 * @returns {String} - resized image url
 */
function resizeImageSrc(src, size) {
  if (src) {
    let ext = '.' + src.split('.').pop()
    let fileName = src.split(ext)[0]
    return `${fileName}_${size}x${ext}`
  } else {
    return 'https://cdn.shopify.com/shopifycloud/shopify/assets/no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c_800x.gif'
  }
}

/**
 * @param {String} src - Shopify image src in order to edit size
 * @param {Integer} width  - Width to crop image down to
 * @param {Integer} height - Height to crop image down to
 * @param  {( 'center' | 'top' | 'bottom' | 'left' | 'right')} crop - the area of the image to focus the crop
 * @returns {String} - cropped image url
 */
function cropImageSrc(src, width, height, crop) {
  if (src) {
    let url = new URL(src)
    if (width) url.searchParams.set('width', width)
    if (height) url.searchParams.set('height', height)
    if (crop) url.searchParams.set('crop', crop)
    return url.href
  } else {
    return 'https://cdn.shopify.com/shopifycloud/shopify/assets/no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c_800x.gif'
  }
}

function swapArrayElements(arr, i, j) {
  arr = [...arr]
  let temp = arr[i]
  arr[i] = arr[j]
  arr[j] = temp
  return arr
}

/**
 *
 * @param {Array} a First array to compare
 * @param {Array} b Second array to compare
 * @returns {Boolean} whether both arrays have same contents
 */
function compareArrays(a, b) {
  if (a.length !== b.length) {
    return false
  }

  for (var i = 0; i < a.length; i++) {
    if (a[i] !== b[i]) {
      return false
    }
  }
  return true
}

/**
 * @description gets shopify product data either via url or pass in product handle
 * @param {String=} handle optional product handle to get or will use current url
 * @returns {object} a js object of product data
 */
async function getProduct(handle) {
  const url = new URL(window.location)
  if (!handle && !url.pathname.includes('product')) {
    console.error('Error: Trying to get product data with out a handle on a non-product page. Pass getProduct a handle.')
    return false
  }
  const productHandle = handle ? `/products/${handle}.js` : `${new URL(window.location).pathname}.js`
  return await get(productHandle)
}

/**
 * @description finds the first or selected variant on homepage
 * @param {String=} product required to find first or selected variant
 * @returns {object} a variant object
 */
function getBuyBoxVariant(product) {
  const url = new URL(window.location)
  if (url.pathname === '/' && product) {
    const variantID = Number(url.searchParams.get('variant'))
    const currentVariant = product.variants.find((variant) => variant.id === variantID)

    return variantID ? currentVariant : product.variants[0]
  }
}

/**
 * Document Ready
 * @description wrapper to run code that needs to wait for DOM to be fully loaded
 * @param {callback} cb - a callback to run once the DOM is ready
 */
function docReady(cb) {
  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    setTimeout(cb, 1) // call on next available tick
  } else {
    document.addEventListener('DOMContentLoaded', cb)
  }
}
/**
 *
 * @param {*} x - variable to be tested if string or not
 * @returns {boolean} - returns true if string
 */
function isString(x) {
  return typeof x === 'string' || x instanceof String
}

/**
 * @description gets all focusable elements within an element
 * @param {HTMLElement} parentNode - element to search for focusable elements within
 * @returns {NodeList} - is nodelist of focusable elements
 */
function getFocusableElements(parentNode) {
  parentNode.querySelectorAll(
    'a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])'
  )
}

/**
 * Viewport Height
 * @description gets the current viewport height
 * @returns {integer} viewport height
 */
function vh() {
  return window.visualViewport.height || window.innerHeight
}

/**
 * Viewport Width
 * @description gets the current viewport width
 * @returns {integer} viewport width
 */
function vw() {
  return window.visualViewport.width || window.innerWidth
}

/**
 * @description used to delay the execution until a certain amount of time has elapsed
 */
var debounce = (() => {
  let timer = 0
  /**
   * @param {callback} callback function to execute after certain amount of milliseconds has elapsed
   * @param {integer} [ms=1500] *default: 1500*, The amount of time to wait before execution, in milliseconds
   */
  return function (callback, ms = 1500) {
    clearTimeout(timer)
    timer = setTimeout(callback, ms)
  }
})()
/**
 *
 * @returns {boolean} - if device is touch or not
 */
function isTouchDevice() {
  return 'ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0
}
/**
 *
 * @param {string} str == A string to be handlized
 * @returns {string} - a handlized string
 */
function handlize(str) {
  return str
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/-$/, '')
    .replace(/^-/, '')
}

/**
 *  Escapes a string with code characters produced by shopify's liquid escape filter i.e. #39; converted back to '
 * @param {string} str - a string to unescape HTML character produced by shopify liquid escape filter i.e.
 * @returns {String} - unescaped string
 */
function unescapeStr(str) {
  return new DOMParser().parseFromString(str, 'text/html').querySelector('html').textContent
}
/**
 *
 * @param {string} key
 * @param {string} value
 * @param {callback=} quotaExceededCallback
 */
function sessionStorageSetItem(key, value, quotaExceededCallback) {
  try {
    sessionStorage.setItem(key, value)
  } catch (err) {
    if (
      err instanceof DOMException &&
      (err.code === 22 ||
        err.code === 1014 ||
        err.name === 'QuotaExceededError' ||
        err.name === 'QUOTA_EXCEEDED_ERR' ||
        err.name === 'NS_ERROR_DOM_QUOTA_REACHED')
    ) {
      let discountCode = sessionStorage.getItem('_discount_code')
      sessionStorage.clear()
      if (discountCode) {
        sessionStorage.setItem('_discount_code', discountCode)
      }
      if (quotaExceededCallback) quotaExceededCallback()
    }
  }
}

/**
 *
 * @param {sting} selector - selector for element you want o see if it exists
 * @param {function} callback -function to run after element exists
 */
var timeWaiting = 0
function waitForElement(selector, callback) {
  if (document.querySelector(selector) !== null) {
    callback()
  } else if (timeWaiting > 2000) {
    console.error(`waitForElement timed out - selector: ${selector}`)
  } else {
    setTimeout(function () {
      timeWaiting += 100
      waitForElement(selector, callback)
    }, 100)
  }
}
export {
  centsToDollars,
  compareArrays,
  cropImageSrc,
  debounce,
  docReady,
  handlize,
  isString,
  isTouchDevice,
  dropZeros,
  getProduct,
  getFocusableElements,
  resizeImageSrc,
  sessionStorageSetItem,
  swapArrayElements,
  unescapeStr,
  vh,
  vw,
  waitForElement,
  changeDecimalSeparator,
  getBuyBoxVariant,
}
